// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .tabs_wrapper {
  border: 1px solid red;
}  */
.tabs {
  margin-bottom: 20px;
  width: 250px;
  display: flex;
  flex-wrap: nowrap;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.tab-titles {
  background-color: #f1f1f1;
  border-radius: 8px;
}

.tab-title {
  padding: 10px;
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
  border: 1px solid #ccc;
  padding: 15px 30px;
  font-size: 16px;
}

.tab-title.active {
  font-weight: bold;
  background: rgb(27, 91, 255);
  color: var(--white-color);
}

.tab-content {
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewDocument/DocComp.js/Tabs.css"],"names":[],"mappings":"AAAA;;IAEI;AACJ;EACE,mBAAmB;EACnB,YAAY;EAEZ,aAAa;EAEb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* .tabs_wrapper {\n  border: 1px solid red;\n}  */\n.tabs {\n  margin-bottom: 20px;\n  width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.tab-titles {\n  background-color: #f1f1f1;\n  border-radius: 8px;\n}\n\n.tab-title {\n  padding: 10px;\n  cursor: pointer;\n  border: none;\n  background: none;\n  outline: none;\n  border: 1px solid #ccc;\n  padding: 15px 30px;\n  font-size: 16px;\n}\n\n.tab-title.active {\n  font-weight: bold;\n  background: rgb(27, 91, 255);\n  color: var(--white-color);\n}\n\n.tab-content {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
